import type { ReactNode } from 'react';

export const symbol_mode_of_travel: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M160-568q0-137 97-224.5T479-880q133 0 227 94t94 258l73-73q9-9 21-9t21 9q9 9 9 21t-9 21L791-435q-9 9-21 9t-21-9L625-559q-9-9-9-21t9-21q9-9 21-9t21 9l73 73q0-132-73-212t-188-80q-108 0-183.5 73.5T220-567q0 88 62 185.5T479-159q20-19 43-41.5t40-39.5q-6-11-9.5-22.5T549-287q0-37 26.5-63.5T639-377q37 0 63 26.5t26 63.5q0 37-26 63.5T639-197q-8 0-15.5-2t-14.5-4q-22 23-43.5 44T520-116q-8 8-18.5 12t-21.5 4q-11 0-22-4t-20-12Q293-247 226.5-356T160-568Z"
		/>
	</svg>
);
